// All requests share nginx's same-origin /api route.
let token = ''
let onUnauthorized = () => {}
export function configureAuth (value, handler) {
  token = value || ''
  if (handler) onUnauthorized = handler
}
async function request (method, path, body, options = {}) {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 30000)
  const headers = { Accept: 'application/json' }
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  if (token && !options.anonymous) headers.Authorization = `Bearer ${token}`
  try {
    const response = await fetch(`${http.defaults.baseURL}/${path.replace(/^\//, '')}`, {
      method, headers, body: body === undefined ? undefined : JSON.stringify(body),
      credentials: 'same-origin', signal: controller.signal
    })
    const text = await response.text()
    let data = null
    try { data = text ? JSON.parse(text) : null } catch (_) { /* Non-JSON proxy errors. */ }
    if (response.ok && text && data === null) throw new Error('La API no devolvió una respuesta válida. Inténtalo de nuevo.')
    if (!response.ok) {
      if (response.status === 401 && !options.anonymous) onUnauthorized()
      const error = new Error(data && data.title ? data.title : 'No se pudo completar la solicitud.')
      error.status = response.status
      error.response = { status: response.status, data }
      throw error
    }
    return { data, status: response.status }
  } catch (error) {
    if (!error.status && (error.name === 'AbortError' || error instanceof TypeError)) error.message = error.name === 'AbortError'
      ? 'La conexión tardó demasiado. Inténtalo de nuevo.'
      : 'No podemos conectar en este momento. Revisa tu conexión e inténtalo de nuevo.'
    throw error
  } finally { clearTimeout(timeout) }
}
const http = {
  defaults: { baseURL: '/api' },
  get: (path, options) => request('GET', path, undefined, options),
  post: (path, body, options) => request('POST', path, body, options),
  put: (path, body, options) => request('PUT', path, body, options),
  delete: (path, options) => request('DELETE', path, undefined, options)
}
export default http
